<template>
    <div class="h-full w-full">
        <div>
            <schedule-list :reportData="reportData" create @pushDataInReportTrigger="pushDataInReportTrigger" />
        </div>
    </div>
</template>

<script>

export default {
    props: {
        reportData: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        ScheduleList: () => import('@/modules/reports/components/ScheduleList.vue')
    },
    methods: {
        validate () {
            return this.reportData.ReportTriggerList.length
        },
        pushDataInReportTrigger (data) {
            this.$emit('pushDataInReportTrigger', data)
        }
    }
}
</script>

<style lang="scss" scoped>
.schedule-list-container {
    margin-top: 15px !important;
}
</style>